import axiosInstance from "../../utils/axiosInstance";

const getRelatedBlog = async ({ tags, id }) => {
  const queryString =
    tags?.length > 0
      ? tags.map((tag) => `tags_like=${tag}`).join("&") + `&id_ne=${id}`
      : null;

  const response = await axiosInstance.get(`/blogs/?${queryString}`);
  return response.data;
};
export default getRelatedBlog;
